


export class CN46N {
  "network";
  "status";
  "text";
  "companyCode";
  "dtImportacao";
  "transacaoOrigem";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CN46N`.
   */
  static getModelName() {
    return "CN46N";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CN46N for dynamic purposes.
  **/
  static factory(data) {
    return new CN46N(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'CN46N',
      plural: 'CN46Ns',
      path: 'CN46Ns',
      properties: {
        "network": {
          name: 'network',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "text": {
          name: 'text',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "transacaoOrigem": {
          name: 'transacaoOrigem',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/CN46N.js